import React, { useState, useEffect } from "react";
import { ResponsivePie } from "@nivo/pie";
import { message } from "antd";
import Bridge from "../../../../constants/Bridge";
import Strings from "../../../../constants/Strings";
import $ from "jquery";

const AlsReport = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [pieReports, setPieReports] = useState([]);
  const [screenCapture, setScreenCapture] = useState("");
  const [totalParticipants, setTotalParticipants] = useState(0);
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    getReportData();
  }, []);

  const getReportData = () => {
    Bridge.reports
      .alsReportPieChartData()
      .then((result) => {
        if (result.status == "1") {
          setReports(result.data);
          setData(result.data);
        }
      })
      .catch((error) => {
        message.error("Something went wrong. Please try again!!", error);
      });
  };

  const setData = (data) => {
    let arr = [];
    for (let item of data) {
      let SUM = Number(
        item.als +
          item.als_ftd +
          item.asymptomatic_gene_carrier +
          item.blood_relative +
          item.documented_reversal +
          item.non_blood_relative +
          item.other_mnd +
          item.pls +
          item.student
      );
      let ONE_PER_OF_SUM = Number(SUM / 100);
      setTotalParticipants(SUM);

      let arr2 = [];
      let obj1 = {
        label: "ALS",
        value: item.als,
        percentage: parseFloat(item.als / ONE_PER_OF_SUM).toFixed(2),
      };
      let obj2 = {
        label: "ALS and Fronto - Temporal Dementia",
        value: item.als_ftd,
        percentage: parseFloat(item.als_ftd / ONE_PER_OF_SUM).toFixed(2),
      };
      let obj3 = {
        label: "Asymptomatic Gene Carrier",
        value: item.asymptomatic_gene_carrier,
        percentage: parseFloat(
          item.asymptomatic_gene_carrier / ONE_PER_OF_SUM
        ).toFixed(2),
      };
      let obj4 = {
        label: "Blood Relative (children and siblings)",
        value: item.blood_relative,
        percentage: parseFloat(item.blood_relative / ONE_PER_OF_SUM).toFixed(2),
      };
      let obj5 = {
        label: "Documented Reversal",
        value: item.documented_reversal,
        percentage: parseFloat(
          item.documented_reversal / ONE_PER_OF_SUM
        ).toFixed(2),
      };
      let obj6 = {
        label: "Non-blood Relative (spouse, friends)",
        value: item.non_blood_relative,
        percentage: parseFloat(
          item.non_blood_relative / ONE_PER_OF_SUM
        ).toFixed(2),
      };
      let obj7 = {
        label: "Other Motor Neuron Disease",
        value: item.other_mnd,
        percentage: parseFloat(item.other_mnd / ONE_PER_OF_SUM).toFixed(2),
      };
      let obj8 = {
        label: "PLS",
        value: item.pls,
        percentage: parseFloat(item.pls / ONE_PER_OF_SUM).toFixed(2),
      };
      let obj9 = {
        label: "Student",
        value: item.student,
        percentage: parseFloat(item.student / ONE_PER_OF_SUM).toFixed(2),
      };

      arr2.push(obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8, obj9);
      arr = arr2;
    }

    setPieReports(arr);
  };

  const pieData =
    pieReports &&
    pieReports.map((item, index) => {
      return {
        id: item.label + " (" + item.percentage + "%) ",
        label: item.label + " (" + item.percentage + "%) ",
        value: item.value,
        color: "#" + Math.floor(Math.random() * 0xffffff).toString(16),
      };
    });

  return (
    <div className="als-mnd-graph-wrapper">
      <div className="row">
        <div
          className="col-lg-12 main-section add-user"
          style={{ paddingTop: 0 }}
        >
          <div
            className="wrapper clearfix position-relative"
            style={{
              paddingTop: 0,
              background: "#fff",
              transform: "scale(1)",
            }}
          >
            <div className="multisteps-form import-participant-block">
              <div className="bg-white" id="main-section">
                <div className="row bg-white" id="section-1">
                  <div className="col-12 col-lg-12" style={{ marginBottom: 40 }}>
                    <div className="wizard-content-form ethnicity-report-1 bg-white diagnosis-report">
                      <div
                        className="wizard-form-field ml-0"
                        style={{ margin: "0px 0 14px 14px" }}
                      >
                        <br />
                        <div className="main-download-button">
                          <h1
                            className="pt-4 graph-heading"
                            style={{
                              fontSize: 27,
                              fontWeight: "600",
                              marginTop: -40,
                              marginBottom: 50,
                            }}
                          >
                            {Strings.dignosisReport} - (Total Participants -{" "}
                            {""}
                            {totalParticipants})
                          </h1>
                        </div>
                        <div
                          style={{
                            width: window.innerWidth > 650 ? "103%" : "100%",
                            margin: "0 auto",
                          }}
                          className="graph-outer"
                        >
                          <ResponsivePie
                            data={pieData}
                            style={{ ovreflowX: "scroll" }}
                            margin={{
                              top: 0,
                              right: $(window).width() < 600 ? 50 : 450,
                              bottom: 80,
                              left: $(window).width() < 600 ? 40 : 170,
                            }}
                            startAngle={-18}
                            innerRadius={0.5}
                            padAngle={0.7}
                            activeOuterRadiusOffset={8}
                            colors={{ scheme: "red_yellow_green" }}
                            borderWidth={1}
                            borderColor={{
                              from: "color",
                              modifiers: [["darker", 0.2]],
                            }}
                            arcLinkLabelsDiagonalLength={0}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#000"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsColor={{ from: "color" }}
                            arcLabelsSkipAngle={10}
                            arcLinkLabelsOffset={-10}
                            arcLabelsTextColor={{
                              from: "color",
                              modifiers: [["darker", 2]],
                            }}
                            defs={[
                              {
                                id: "dots",
                                type: "patternDots",
                                background: "inherit",
                                color: "#000",
                                size: 4,
                                padding: 1,
                                stagger: true,
                              },
                              {
                                id: "lines",
                                type: "patternLines",
                                background: "inherit",
                                color: "#000",
                                rotation: -45,
                                lineWidth: 6,
                                spacing: 10,
                              },
                            ]}
                            fill={[
                              {
                                match: {
                                  id: "ruby",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "c",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "go",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "python",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "scala",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "lisp",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "elixir",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "javascript",
                                },
                                id: "lines",
                              },
                            ]}
                            legends={[
                              {
                                anchor: "right",
                                direction: "column",
                                justify: false,
                                translateX: $(window).width() < 600 ? 160 : 590,
                                translateY: $(window).width() < 600 ? 240 : 9,
                                itemsSpacing: 0,
                                itemWidth: 400,
                                itemHeight: 26,
                                itemTextColor: "#000",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: 23,
                                symbolShape: "circle",
                                width: 200,
                                effects: [
                                  {
                                    on: "hover",
                                    style: {
                                      itemTextColor: "#000",
                                    },
                                  },
                                ],
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlsReport;
